import React from 'react';
import PropTypes from 'prop-types';
import {
  InsertResourceDialog,
  acceptDocuments,
  insertValidationDocuments
} from '../../../content-edit-controls';

const InsertDocumentDialogWindow = ({
  onSave,
  onCancel,
  env,
  params
}) =>
{

  const { mode = 'InsertDocument' } = params;
  const isInsertDocumentMode = mode === 'InsertDocument';

  const handleSave = (resource) =>
  {
    onSave(resource);
  };

  return (
    <InsertResourceDialog
      isInsertDocumentMode={isInsertDocumentMode}
      onInsert={handleSave}
      onCancel={onCancel}
      accept={acceptDocuments}
      insertValidation={insertValidationDocuments}
      mode={mode}
      env={env}
    />
  );
};

InsertDocumentDialogWindow.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  env: PropTypes.shape({
    location: PropTypes.shape({
      protocol: PropTypes.string,
      host: PropTypes.string,
      port: PropTypes.string
    })
  }).isRequired
};

InsertDocumentDialogWindow.defaultProps = {
  env: window
};

export default InsertDocumentDialogWindow;